<template>
  <main-template>
    <v-row>
      <v-col cols="12">
        <h2 class="text-h5 mb-2">{{ escola?.descricao }}</h2>
        <e-label>Pesquise uma unidade escolar aqui</e-label>
        <v-autocomplete
          v-model="escola"
          :items="this.franquiasList"
          item-text="descricao"
          item-value="id"
          dense
          return-object
          filled
          label="Pesquise uma escola"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-tabs
      v-model="tab"
      grow
      background-color="transparent"
      class="elevation-1 mb-6"
      color="yellowTheme"
    >
      <v-tab href="#turmas" class="text-capitalize">
        <v-icon left>groups</v-icon>
        Turmas
      </v-tab>
      <v-tab href="#relatorios" class="text-capitalize">
        <v-icon left>query_stats</v-icon>
        Relatórios
      </v-tab>
      <v-tab href="#documentos" class="text-capitalize">
        <v-icon left>description</v-icon>
        Documentos
      </v-tab>
      <v-tab href="#gestao" class="text-capitalize">
        <v-icon left>manage_accounts</v-icon>
        Gestão
      </v-tab>
      <v-tab href="#notifiq" class="text-capitalize">
        <v-icon left>mdi-bell-ring</v-icon>
        Notifiq
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="mt-4">
      <!-- Turmas -->
      <v-tab-item value="turmas" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <!-- Turmas - Escola atual (sem alunos) -->
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="yellowTheme"
              @click="listarTurmasEscola(escola.id)"
              :id="`card-turmas-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Turmas (sem alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Todas as turmas - Todas as escolas-->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="alunosPorUnidades(escola?.id)"
              :id="`card-todas-turmas`"
            >
              <v-card-title>
                <v-icon large left> groups </v-icon>
                <span class="title font-weight-light">Turmas (com alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Todas as turmas - Todas as escolas (sem alunos) -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="yellowTheme" @click="listarTodasTurmas()" :id="`card-todas-turmas`">
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Todas as turmas (sem alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Todas as turmas - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="escolasTurmasAlunos()"
              :id="`card-todas-escolas-turmas`"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Todas as turmas (com alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->
        </v-row>
      </v-tab-item>
      <!-- Fim - Turmas -->

      <!-- Relatórios -->
      <v-tab-item value="relatorios" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <!-- Relatório aulas - Relatório inserção de aulas -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="yellowTheme" @click="insercaoAulas()" :id="`card-todas-turmas`">
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Relatório de Aulas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Inserção de aulas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de faltas - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="relatoriosEvasao(escola?.id)"
              :id="`card-relatorio-faltas`"
            >
              <v-card-title>
                <v-icon large left> fa fa-chalkboard-teacher </v-icon>
                <span class="title font-weight-light">Relatório de Faltas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="faltasPorDisciplinaTurmas()"
              :id="`card-relatorio-faltas-disciplina`"
            >
              <v-card-title>
                <v-icon large left> fa fa-calendar-check </v-icon>
                <span class="title font-weight-light">Faltas por Disciplina</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Selecionar Turmas</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <!-- Fim - Relatórios -->

      <v-tab-item value="notifiq" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card color="yellowTheme" @click="abrirDialogNotifiq" :id="`card-presencas-notifiq`">
              <v-card-title>
                <v-icon large left>mdi-bell-ring</v-icon>
                <span class="title font-weight-light">Presenças</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="yellowTheme"
              @click="alunosMatriculadosNotifiq(escola.id)"
              :id="`card-alunos-notifiq`"
            >
              <v-card-title>
                <v-icon large left>mdi-account-group</v-icon>
                <span class="title font-weight-light">Alunos por Turma</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="yellowTheme"
              @click="abrirDialogFaltantesNotifiq"
              :id="`card-faltantes-notifiq`"
            >
              <v-card-title>
                <v-icon large left>mdi-account-alert-outline</v-icon>
                <span class="title font-weight-light">Alunos sem Presença</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-dialog v-model="dialogNotifiq" max-width="520">
          <v-card>
            <v-card-title class="text-h6 yellowTheme">
              Relatório de Presenças Notifiq
            </v-card-title>
            <v-card-text class="pt-6">
              <v-menu
                v-model="dialogDataInicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="notifiqForm.dataInicio"
                    label="Data inicial"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="notifiqForm.dataInicio"
                  locale="pt-br"
                  @input="dialogDataInicio = false"
                />
              </v-menu>

              <v-menu
                v-model="dialogDataFim"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="notifiqForm.dataFim"
                    label="Data final"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="notifiqForm.dataFim"
                  locale="pt-br"
                  @input="dialogDataFim = false"
                />
              </v-menu>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text @click="dialogNotifiq = false">Cancelar</v-btn>
              <v-btn
                color="yellowTheme"
                :disabled="!notifiqIntervaloSelecionado"
                @click="presencasNotifiq(escola.id)"
              >
                Gerar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogFaltantesNotifiq" max-width="520">
          <v-card>
            <v-card-title class="text-h6 yellowTheme">
              Relatório de Alunos sem Presença - Notifiq
            </v-card-title>
            <v-card-text class="pt-6">
              <v-menu
                v-model="dialogDataFaltantes"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="notifiqFaltantesForm.data"
                    label="Data"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="notifiqFaltantesForm.data"
                  locale="pt-br"
                  @input="dialogDataFaltantes = false"
                />
              </v-menu>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text @click="dialogFaltantesNotifiq = false">Cancelar</v-btn>
              <v-btn
                color="yellowTheme"
                :disabled="!notifiqFaltantesDataSelecionada"
                @click="faltantesNotifiq(escola.id)"
              >
                Gerar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-tab-item>
      <!-- Fim - Notifiq -->

      <!-- Documentos -->
      <v-tab-item value="documentos" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <!-- Boletins - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="boletinsFranquia(escola.id)"
              :id="`card-boletins-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>receipt_long</v-icon>
                <span class="title font-weight-light">Boletins</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatórios BNCC - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="relatoriosBnccFranquia(escola.id)"
              :id="`card-relatorios-bncc-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>child_care</v-icon>
                <span class="title font-weight-light">Relatórios BNCC</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de planos lançados - Escola atual -->
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="yellowTheme"
              @click="relatorioDeListagemDosPlanosLancados(escola.id)"
              :id="`card-planos-lancados-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>auto_stories</v-icon>
                <span class="title font-weight-light">Planos lançados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de planos lançados - Todas as escolas -->
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="yellowTheme"
              @click="relatorioDeListagemDosPlanosLancadosGeral(escola.id)"
              :id="`card-planos-lancados-geral`"
            >
              <v-card-title>
                <v-icon large left>auto_stories</v-icon>
                <span class="title font-weight-light">Planos lançados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório Plano Anual - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="planoAnualFranquiaAtual(escola?.id)"
              :id="`card-plano-anual-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório de Plano Anual</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="planoAnualFranquias()"
              :id="`card-plano-anual-geral`"
            >
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório de Plano Anual</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Todas as escolas </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <!-- Fim - Documentos -->

      <!-- Gestão -->
      <v-tab-item value="gestao" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <!-- Relatório de lotação - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="lotacaoEscola(escola?.id)"
              :id="`card-lotacao-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório de lotação</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Escola Atual </v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de lotação - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="yellowTheme" @click="lotacaoGeral()" :id="`card-lotacao-geral`">
              <v-card-title>
                <v-icon large left>mdi-book-variant</v-icon>
                <span class="title font-weight-light">Relatório de lotação</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de lotação por escola - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="yellowTheme" @click="lotacao()" :id="`card-lotacao-escola`">
              <v-card-title>
                <v-icon large left>mdi-book-variant</v-icon>
                <span class="title font-weight-light">Relatório de lotação por escola</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório situação alunos - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="relatorioAlunosAprovadoReprovado(escola?.id)"
              :id="`card-relatorio-alunos-aprovado-reprovado`"
            >
              <v-card-title>
                <v-icon large left> fa fa-chalkboard-teacher </v-icon>
                <span class="title font-weight-light">Relatório situação alunos</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório Por Alunos (Censo) - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="relatoriosCensoAlunoFranquia(escola?.id)"
              :id="`card-relatorios-censo-aluno-${escola.id}`"
            >
              <template slot="progress">
                <v-progress-linear color="yellowTheme" height="5" indeterminate></v-progress-linear>
              </template>
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório Censo (Alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Escola atual </v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório Por Professor (Censo) - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="relatoriosCensoProfessorFranquia(escola?.id)"
              :id="`card-relatorios-censo-professor-${escola.id}`"
            >
              <template slot="progress">
                <v-progress-linear color="yellowTheme" height="5" indeterminate></v-progress-linear>
              </template>
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório Censo (Professores)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Escola atual </v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Professores por disciplina - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="qtdProfessoresPorDisciplina()"
              :id="`card-professores-por-disciplina`"
            >
              <template slot="progress">
                <v-progress-linear color="yellowTheme" height="5" indeterminate></v-progress-linear>
              </template>
              <v-card-title>
                <v-icon large left> fa fa-chalkboard-teacher </v-icon>
                <span class="title font-weight-light">Professores por disciplina</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Alunos não matriculados - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="alunosNaoMatriculados(escola?.id)"
              :id="`card-alunos-nao-matriculados-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left> fa fa-chalkboard-teacher </v-icon>
                <span class="title font-weight-light">Alunos não matriculados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Alunos não matriculados - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="alunosNaoMatriculadosGeral()"
              :id="`card-alunos-nao-matriculados-geral`"
            >
              <v-card-title>
                <v-icon large left> fa fa-chalkboard-teacher </v-icon>
                <span class="title font-weight-light">Alunos não matriculados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Resumo movimento escolar - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="resumoMovimentoEscolar(escola?.id)"
              :id="`card-resumo-movimento-escolar-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left> fa fa-chalkboard-teacher </v-icon>
                <span class="title font-weight-light">Resumo movimento escolar</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Escola atual</v-card-text>
            </v-card>
          </v-col>

          <!-- Matrículas Realizadas - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              :id="`card-matriculas-realizadas`"
              color="yellowTheme"
              @click="openMatriculasModal"
            >
              <v-card-title>
                <v-icon large left>mdi-book-variant</v-icon>

                <span class="title font-weight-light"> Matrículas Realizadas </span>
              </v-card-title>

              <v-card-text class="subtitle font-weight-bold"> Todas as escolas </v-card-text>
            </v-card>
          </v-col>

          <!-- Modal -->
          <v-dialog v-model="matriculasModal" max-width="500" persistent>
            <v-card>
              <v-card-title class="headline"> Selecione o período </v-card-title>

              <v-card-text>
                <v-row>
                  <!-- Data inicial -->
                  <v-col cols="12">
                    <v-menu
                      v-model="menuDataInicial"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatarDataBR(matriculasFiltros.dataInicial)"
                          label="Data Inicial"
                          prepend-icon="mdi-calendar"
                          readonly
                          outlined
                          dense
                          required
                          :error="matriculasTentouEnviar && !matriculasFiltros.dataInicial"
                          :error-messages="
                            matriculasTentouEnviar && !matriculasFiltros.dataInicial
                              ? ['Data inicial obrigatória']
                              : []
                          "
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>

                      <v-date-picker
                        v-model="matriculasFiltros.dataInicial"
                        locale="pt-br"
                        no-title
                        @input="menuDataInicial = false"
                      />
                    </v-menu>
                  </v-col>

                  <!-- Data final -->
                  <v-col cols="12">
                    <v-menu
                      v-model="menuDataFinal"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatarDataBR(matriculasFiltros.dataFinal)"
                          label="Data Final"
                          prepend-icon="mdi-calendar"
                          readonly
                          outlined
                          dense
                          required
                          :error="
                            (matriculasTentouEnviar && !matriculasFiltros.dataFinal) ||
                            matriculasPeriodoInvalido
                          "
                          :error-messages="
                            matriculasPeriodoInvalido
                              ? ['A data de final deve ser posterior ou igual à data de abertura.']
                              : matriculasTentouEnviar && !matriculasFiltros.dataFinal
                              ? ['Data final obrigatória']
                              : []
                          "
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>

                      <v-date-picker
                        v-model="matriculasFiltros.dataFinal"
                        locale="pt-br"
                        no-title
                        @input="menuDataFinal = false"
                      />
                    </v-menu>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-spacer />

                <!-- Fecha modal -->
                <v-btn text color="grey" @click="matriculasModal = false"> Cancelar </v-btn>

                <!-- Executa método -->
                <v-btn
                  color="primary"
                  :disabled="
                    !matriculasFiltros.dataInicial ||
                    !matriculasFiltros.dataFinal ||
                    matriculasPeriodoInvalido
                  "
                  @click="confirmarMatriculasRealizadas"
                >
                  Confirmar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Quantidade de alunos - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="yellowTheme" @click="qtdAlunos()" :id="`card-qtd-alunos-todas-escolas`">
              <template slot="progress">
                <v-progress-linear color="yellowTheme" height="5" indeterminate></v-progress-linear>
              </template>
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Quantidade de alunos</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Todas as escolas </v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de Alunos (PCD) - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="yellowTheme"
              @click="alunosPCDPorUnidade(escola?.id)"
              :id="`card-alunos-pcd-todas-escolas`"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>

                <span class="title font-weight-light">Relatório de Alunos (PCD)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <!-- Fim - Gestão -->
    </v-tabs-items>
    <!--  -->

    <e-modal-boletim-franquia
      :dialog="dialogBoletimFranquia"
      :franquia_id="franquia_id"
      @dialogChange="dialogBoletimFranquia = $event"
    ></e-modal-boletim-franquia>
  </main-template>
</template>
<script>
import { mapGetters } from "vuex";
import Axios from "../../plugins/Axios";

export default {
  name: "Relatórios",

  data() {
    return {
      dialogBoletimFranquia: false,
      dialogDataFaltantes: false,
      dialogDataFim: false,
      dialogDataInicio: false,
      dialogFaltantesNotifiq: false,
      dialogNotifiq: false,
      escola: {
        descricao: null,
        id: null,
      },
      franquia_id: null,
      franquiasList: null,
      menuDataFinal: false,
      menuDataInicial: false,
      matriculasFiltros: {
        dataInicial: null,
        dataFinal: null,
      },
      matriculasModal: false,
      matriculasTentouEnviar: false,
      notifiqFaltantesForm: {
        data: null,
      },
      notifiqForm: {
        dataFim: null,
        dataInicio: null,
      },
      tab: null,
      user: null,
    };
  },

  computed: {
    matriculasPeriodoInvalido() {
      return (
        this.matriculasFiltros.dataInicial &&
        this.matriculasFiltros.dataFinal &&
        this.matriculasFiltros.dataFinal < this.matriculasFiltros.dataInicial
      );
    },
    notifiqFaltantesDataSelecionada() {
      return Boolean(this.notifiqFaltantesForm.data);
    },
    notifiqIntervaloSelecionado() {
      return Boolean(this.notifiqForm.dataInicio && this.notifiqForm.dataFim);
    },
  },

  methods: {
    abrirDialogFaltantesNotifiq() {
      this.dialogFaltantesNotifiq = true;
    },
    abrirDialogNotifiq() {
      this.dialogNotifiq = true;
    },
    async alunosMatriculadosNotifiq(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosMatriculadosNotifiq(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async alunosNaoMatriculados(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosNaoMatriculados(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async alunosNaoMatriculadosGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosNaoMatriculadosGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async alunosPCDPorUnidade(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosPCDPorUnidadeEScolar(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async alunosPorUnidades(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosPorUnidadeEScolar(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async boletinsFranquia(franquia_id) {
      try {
        this.franquia_id = franquia_id;
        this.dialogBoletimFranquia = !this.dialogBoletimFranquia;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    confirmarMatriculasRealizadas() {
      this.matriculasTentouEnviar = true;

      if (!this.matriculasFiltros.dataInicial || !this.matriculasFiltros.dataFinal) {
        return;
      }

      if (this.matriculasPeriodoInvalido) {
        return;
      }

      this.matriculasModal = false;

      this.matriculasRelizadas(
        this.matriculasFiltros.dataInicial,
        this.matriculasFiltros.dataFinal
      );

      this.matriculasFiltros.dataInicial = null;
      this.matriculasFiltros.dataFinal = null;
      this.matriculasTentouEnviar = false;
    },
    async escolasTurmasAlunos() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.escolasTurmasAlunos();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async faltantesNotifiq(franquia_id) {
      if (!this.notifiqFaltantesForm.data) {
        this.$toast.danger("Selecione a data do relatório.");
        return;
      }

      this.dialogFaltantesNotifiq = false;

      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.faltantesNotifiq(
          parseInt(franquia_id, 10),
          this.notifiqFaltantesForm.data
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async faltasPorDisciplinaTurmas() {
      try {
        this.$router.push({
          name: "relatorios-faltas-disciplina-turmas",
          params: { franquia_id: this.escola?.id },
        });
      } catch (error) {
        this.$handleError(error);
      }
    },
    formatarDataBR(data) {
      if (!data) return "";

      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    async getUser() {
      this.user = await this.$services.authService.getCurrentUser();
      this.escola = this.user.franquia;
    },
    async insercaoAulas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.insercaoAulas();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async inscritosCongresso() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.insercaoAulas();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async listarFranquias() {
      try {
        this.franquiasList = await this.$services.franquiasService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async listarTodasTurmas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.listarTodasTurmas();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async listarTurmasEscola(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.listarTurmasFranquia(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async lotacao() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacao();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async lotacaoEscola(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacaoEscola(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async lotacaoGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacaoGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async matriculasRelizadas(dataInicial, dataFinal) {
      try {
        this.$loaderService.open("Carregando dados...");

        await this.$services.relatoriosService.matriculasRealizadas(dataInicial, dataFinal);
      } catch (error) {
        if (error instanceof ArrayBuffer) {
          try {
            const text = new TextDecoder("utf-8").decode(error);
            const { message } = JSON.parse(text);

            this.$toast.danger(message || "Erro inesperado.");
          } catch (_) {
            this.$toast.danger("Erro inesperado.");
          }
        }
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    openMatriculasModal() {
      this.matriculasTentouEnviar = false;

      this.matriculasFiltros = {
        dataInicial: null,
        dataFinal: null,
      };

      this.matriculasModal = true;
    },
    async planoAnualFranquiaAtual(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.planoAnualFranquiaAtual(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async planoAnualFranquias() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.planoAnualFranquias();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async presencasNotifiq(franquia_id) {
      if (!this.notifiqForm.dataInicio || !this.notifiqForm.dataFim) {
        this.$toast.danger("Selecione a data início e a data fim.");
        return;
      }

      if (this.notifiqForm.dataFim < this.notifiqForm.dataInicio) {
        this.$toast.danger("A data fim não pode ser menor que a data início.");
        return;
      }

      this.dialogNotifiq = false;

      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.presencasNotifiq(
          parseInt(franquia_id, 10),
          this.notifiqForm.dataInicio,
          this.notifiqForm.dataFim
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async qtdAlunos() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.qtdAlunos();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async qtdProfessoresPorDisciplina() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.qtdProfessoresPorDisciplina();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async relatorioAlunosAprovadoReprovado(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioAlunosAprovadoReprovado(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async relatorioDeListagemDosPlanosLancados(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioDeListagemDosPlanosLancados(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async relatorioDeListagemDosPlanosLancadosGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioDeListagemDosPlanosLancadosGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async relatoriosBnccFranquia(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosBnccFranquia(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async relatoriosCensoAlunoFranquia(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosCensoAlunoFranquia(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$toast.danger("Não foi possível carregar a informação solicitada! Tente novamente!");
      } finally {
        this.$loaderService.close();
      }
    },

    async relatoriosCensoProfessorFranquia(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosCensoProfessorFranquia(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$toast.danger("Não foi possível carregar a informação solicitada! Tente novamente!");
      } finally {
        this.$loaderService.close();
      }
    },

    async relatoriosEvasao(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosEvasao(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async resumoMovimentoEscolar(fraquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.resumoMovimentoEscolar(fraquia_id);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },

  mounted() {
    this.$loaderService.open("Carregando dados...");
    this.$loaderService.close();
    this.listarFranquias();
    this.getUser();
  },
};
</script>

<style scoped>
.v-autocomplete {
  border-radius: 8px;
  overflow: hidden;
}

.v-card {
  border-left: 4px solid transparent;
  border-radius: 8px !important;
  height: 100%;
  overflow: hidden;
  transition: all 0.8s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.v-card:before {
  background: currentColor;
  bottom: 0;
  content: "";
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: opacity 0.3s;
}

.v-card:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.08) !important;
  transform: translateY(-3px);
}

.v-card:hover:before {
  opacity: 0.04;
}

.v-card.yellowTheme {
  background: linear-gradient(to right, #fff7e4, #ffffff);
  border-left-color: var(--v-yellowTheme-base);
}

.v-card.success {
  background: linear-gradient(to right, #f0fff0, #ffffff);
  border-left-color: var(--v-success-base);
}

.v-col {
  padding-bottom: 16px;
  padding-top: 8px;
}

.v-row:not(:last-child) {
  margin-bottom: 16px;
}

.v-tab {
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.v-tab--active {
  background-color: rgba(255, 255, 255, 0.062);
  font-weight: 600;
}

.v-tab-item {
  padding: 8px 0;
}

.v-tabs {
  border-radius: 8px;
}

@media (max-width: 960px) {
  .v-card__title {
    font-size: 1rem !important;
    padding: 12px !important;
  }

  .v-card__text {
    font-size: 0.875rem !important;
    padding: 0 12px 12px !important;
  }

  .v-tab {
    font-size: 0.75rem;
    min-width: auto;
    padding: 0 12px;
  }

  .v-tab .v-icon {
    font-size: 1.25rem !important;
    margin-right: 4px !important;
  }
}
</style>
